// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1c7sw","tab":"Tabs_tab__hi2e7","tabActive":"Tabs_tabActive__3s7A2"};